import { withTranslation } from 'react-i18next'
import ChangePassword from './ChangePassword'
import withReduxForm from './withReduxForm'

export default withReduxForm(withTranslation()(ChangePassword))
